import { create } from 'zustand'

interface FooterStore {
  isInView: boolean
  setIsInView: (isInView: boolean) => void
}

export const useFooter = create<FooterStore>()((set) => {
  return {
    isInView: false,
    setIsInView: (isInView) => {
      set({
        isInView,
      })
    },
  }
})
